module.exports = __webpack_public_path__ + "static/media/background.f631a50c.jpg";